import "./src/styles/global.css";

import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { AppProviders } from "./src/providers";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => (
  <AppProviders>{element}</AppProviders>
);
